import { Link } from 'react-router-dom';
import React from 'react';

const BlogItem = ({currentBlogItems}) => {
    return (
        <>
            {currentBlogItems?.map((data, id) => (
                <div className="col-lg-6 mt-25" key={id}>
                    {/* Changed to row layout and added stretch to match heights */}
                    <div className="blog__three-item mt-25" style={{ 
                        display: 'flex', 
                        flexDirection: 'row', 
                        alignItems: 'stretch',
                        border: '1px solid #eaeaec', 
                        borderRadius: '8px', 
                        overflow: 'hidden', 
                        backgroundColor: '#fff',
                        height: '100%'
                    }}>
                        
                        {/* Left Side Image Container (40% Width) */}
                        <div className="blog__three-item-image" style={{ width: '40%', flexShrink: 0 }}>
                            <Link to={`/blog/${data.id}`} style={{ display: 'block', height: '100%' }}>
                                <img src={data.image} alt={data.title} style={{ width: '100%', height: '100%', objectFit: 'cover', minHeight: '180px' }} />
                            </Link>                        
                        </div>
                        
                        {/* Right Side Content Container (60% Width) */}
                        <div className="blog__three-item-content" style={{ 
                            width: '60%', 
                            padding: '20px 25px', 
                            display: 'flex', 
                            flexDirection: 'column', 
                            justifyContent: 'center' 
                        }}>
                            {/* Adjusted Title Font Size */}
                            <h4 style={{ marginBottom: '10px', fontSize: '18px', lineHeight: '1.4' }}>
                                <Link to={`/blog/${data.id}`}>{data.title}</Link>
                            </h4>
                            
                            {/* 2-Line Summary with smaller font size */}
                            <p style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                marginBottom: '15px',
                                color: '#666',
                                fontSize: '14px',
                                lineHeight: '1.6'
                            }}>
                                {data.description}
                            </p>
                            
                            <Link className="more_btn" to={`/blog/${data.id}`} style={{ marginTop: 'auto', fontSize: '14px', fontWeight: '600' }}>
                                Read More<i className="flaticon-right-up" style={{ marginLeft: '5px' }}></i>
                            </Link>
                        </div>
                    </div>
                </div>
            ))}            
        </>
    );
};

export default BlogItem;